<template>
    <v-container fluid>
        <v-row class="px-0 py-0 my-0 danger-el-heigth d-flex danger-paddings danger-alert mt-5" v-if="isNewErrorExists" id="id_danger-err-message">
            <div class="danger-alert ml-5" role="alert">
                New Errors exists, view logs
            </div>

        </v-row>
        <v-row class="px-0 py-0 my-0 mt-5">
            <v-col cols="3">
                <RangeFilter
                        :end="dateEnd"
                        :start="dateStart"
                        @getDates="getDates"
                        :excludePeriod="excludePeriod"
                        :defaultPeriod="defaultPeriod"
                        :setDates="true"
                        :disabled="loaded"
                />
            </v-col>
            <v-col cols="4" sm="2"><v-select v-model="filters.task_type" :items="TaskTypes" outlined dense label="Task Type"></v-select></v-col>
            <v-col cols="4" sm="2"><v-select v-model="filters.msg_type" :items="['All','Info','Error','Alert']" outlined dense label="Type"></v-select></v-col>
            <v-spacer></v-spacer>

            <last-time-updated :selectedDate="'updateOrders'" class=" mt-0 mt-md-4"/>

        </v-row>

        <div>
            <h2>Log Table</h2>
        </div>


        <v-hover v-model="hoverOnTable" id="table-cruise-campaign">
            <v-card-text>
                <div class="d-flex justify-space-between">
                    <v-btn
                        class="mx-2 scroll-btn btn-left-arrow"
                        fab
                        small
                        @click="scrollingLeft"
                    >
                        <v-icon>
                            mdi-arrow-left
                        </v-icon>
                    </v-btn>
                    <v-btn
                        class="mx-2 scroll-btn btn-right-arrow"
                        fab
                        small
                        @click="scrollingRight"
                    >
                        <v-icon>
                            mdi-arrow-right
                        </v-icon>
                    </v-btn>
                </div>
                <v-data-table
                    :footer-props="{

              'items-per-page-options': [10, 25, 50, 75, 100, -1],
              'items-per-page':25,
              }"
                    fixed-header
                    :items-per-page="25"
                    height="538px"
                    item-key="'Id'"
                    v-model="selected"
                    :headers="headers"
                    :items="dataLogsRecords"

                    :show-select="managementRight"
                    :loading="loaded"
                    :server-items-length="totalRows"
                    :options.sync="optionsDataTable"
                    loading-text="Loading... Please wait"
                    id="datatable"
                    class="elevation-0 table-main-container"

                >

                    <template v-slot:header.event_type="{ header }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                            </template>
                        </v-tooltip>
                    </template>


                    <template v-slot:header.task_name="{ header }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                            </template>
                        </v-tooltip>
                    </template>

                    <template v-slot:header.task_params="{ header }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                            </template>
                        </v-tooltip>
                    </template>

                    <template v-slot:header.message_data="{ header }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                            </template>
                        </v-tooltip>
                    </template>


                    <template v-slot:header.error_data="{ header }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                            </template>
                        </v-tooltip>
                    </template>

                    <template v-slot:header.created_at="{ header }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                  <span v-on="on">
                      <nobr>{{ header.text }}</nobr>

                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                            </template>
                        </v-tooltip>
                    </template>

                    <template v-slot:item.created_at="{ item }">
                        <!-- <span><a target="_blank" :href="`https://my.sendinblue.com/camp/report/id/`+item.id ">{{item.campaignName}}</a></span> -->
                        <span> <nobr>{{item.created_at}}</nobr></span>

                    </template>



                </v-data-table>
            </v-card-text>
        </v-hover>

        <v-spacer></v-spacer>
        <div class="mt-5">
            <h2>Last Task Activity</h2>
        </div>

        <!-- LAST ACTIVITY TASK TABLE -->

        <v-hover v-model="hoverOnTableLastActivity" id="table-last-activity" class="mt-5">
            <v-card-text>
                <div class="d-flex justify-space-between">
                    <v-btn
                            class="mx-2 scroll-btn btn-left-arrow"
                            fab
                            small
                            @click="scrollingLeft"
                    >
                        <v-icon>
                            mdi-arrow-left
                        </v-icon>
                    </v-btn>
                    <v-btn
                            class="mx-2 scroll-btn btn-right-arrow"
                            fab
                            small
                            @click="scrollingRight"
                    >
                        <v-icon>
                            mdi-arrow-right
                        </v-icon>
                    </v-btn>
                </div>

                <v-data-table
                        :footer-props="{
              'items-per-page-options': [ 50]
              }"
                        fixed-header
                        height="538px"
                        v-model = "selected_last_activ"
                        :headers="header_t_last_activity"
                        :items="dataLogsLastActivityRecords"
                        :item-class="itemRowBackground"

                        :loading="loaded_t_last_acitivty"
                        :server-items-length="dataLogsLastActivityRecords.length"
                        :options.sync="optionsDataTable_LastRun"
                        loading-text="Loading... Please wait"
                        id="datatable"
                >


                    <template v-slot:header.task_name="{ header }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                            </template>
                        </v-tooltip>
                    </template>

                    <template v-slot:header.task_params="{ header }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                            </template>
                        </v-tooltip>
                    </template>

                    <template v-slot:header.created_at="{ header }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                            </template>
                        </v-tooltip>
                    </template>


                </v-data-table>
            </v-card-text>
        </v-hover>

    </v-container>
</template>

<script>

import RangeFilter from '@/components/filters/RangePicker'
import LastTimeUpdated from "@/views/LastTimeUpdated.vue";
import axios from "@/api/axios-auth";
import ErrorsLogChecker from "@/plugins/ErrorLogsChecker";


const EMessageTypes = {
    Error_type: "Error",
}

export default ({
    name: "logs-job-component",
    components: {
        LastTimeUpdated,
        RangeFilter,

    },



    data(){
        return {
            dateEnd: new Date().toISOString().substr(0, 10),
            dateStart: new Date(
                Date.UTC(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1)).toISOString().substr(0, 10),

            pagination: {
                page: 1
            },
            excludePeriod: [],
            defaultPeriod: 4,
            filters: {
                'task_type': null,
                'msg_type': null,
            },
            TaskTypesAndSubtypes:[], // list [ {JobName: 'AD_GOOGLE_DOWNLOADER', JobArgs: '1'} ]
            TaskTypes:[],
            dataLogsRecords:[],
            dataLogsLastActivityRecords:[],

            loaded: false,
            loaded_t_last_acitivty:false,
            hoverOnTable: false,
            hoverOnTableLastActivity:false,
            totalRows: 0,
            optionsDataTable: {},
            optionsDataTable_LastRun: {},

            selected: [],
            selected_last_activ:[],
            selectedTmp: [],
            selectedAd: 0,
            selectedHeaders: [],
            rights: [],

            errors_new:[],
            errors_not_running:[],

            headers: [

                {text: 'Event Type', value: 'event_type', class: 'black--text', sortable: false},
                {text: 'Task Name', value: 'task_name', class: 'black--text', sortable: false},
                {text: 'Task Params', value: 'task_params', class: 'black--text', sortable: false},
                /*
                task_name: "TEST"
                        task_params: null
                * */
                {text:'Message', value:'message_data',class: 'black--text', sortable: false},
                {text:'Error', value:'error_data',class: 'black--text', sortable: false },
                {text:'Time', value:'created_at',class: 'black--text', sortable: false },
            ],
            value: [
                {text: 'Event Type', value: 'event_type', class: 'black--text', sortable: false},
                {text: 'Task Name', value: 'task_name', class: 'black--text', sortable: false},
                {text: 'Task Params', value: 'task_params', class: 'black--text', sortable: false},
                {text:'Message', value:'message_data',class: 'black--text', sortable: false},
                {text:'Error', value:'error_data',class: 'black--text', sortable: false },
                {text:'Time', value:'created_at',class: 'black--text', sortable: false },
                ],

            header_t_last_activity:[
                {text: 'Task Name', value: 'task_name', class: 'black--text', sortable: false},
                {text: 'Task Params', value: 'task_params', class: 'black--text', sortable: false},
                {text:'Time', value:'created_at',class: 'black--text', sortable: false },
            ],
            values_t_last_activity:[
                {text: 'Task Name', value: 'task_name', class: 'black--text', sortable: false},
                {text: 'Task Params', value: 'task_params', class: 'black--text', sortable: false},
                {text:'Time', value:'created_at',class: 'black--text', sortable: false },
            ]
        }
    },
    mounted(){
        this.getTaskLastActivity();
        axios
            .get('/users/me')
            .then(response => {
                this.role = response.data.data.role
                this.rights = response.data.data.rights
            });

        this.load_jobs_types();
        this.load_logs( this.dateStart, this.dateEnd  );
        this.checkErrorsExist();
    },
    watch:{
        hoverOnTable() {
            this.showScrollingArrows()
        },
        optionsDataTable: {
            handler() {
                this.load_logs(this.dateStart, this.dateEnd);
                return
            },
            deep: true,
        },
        optionsDataTable_LastRun:{
            handler() {
                return
            },
            deep: true,

        },
        filters: {
            handler() {
                this.load_logs(this.dateStart, this.dateEnd)
            },
            deep: true,
        },

    },
    computed: {
        managementRight() {
            return (this.role === "Admin")
                ? true
                : this.rights.includes('cruiseCampaignManagement')
        },
        isNewErrorExists(){

            const errchecker = new ErrorsLogChecker(null)
            let res = errchecker.isNewErrorsExists( this.errors_new, this.errors_not_running )
            return res
        },
    },

    methods:{

        getDates(dates) {
            this.dateStart = dates.dateStart
            this.dateEnd = dates.dateEnd
            this.pagination.page = 1
            this.load_logs(this.dateStart, this.dateEnd)
        },

        load_jobs_types(){

            axios
                .get(`/logs/tasktypes`)
                .then(response => {
                    // data = list [ {JobName: 'AD_GOOGLE_DOWNLOADER', JobArgs: '1'} ]
                    this.TaskTypesAndSubtypes = response.data
                    this.TaskTypes = response.data.map(el=>el['JobName'])
                    this.TaskTypes.push('All')
                })

        },
        load_logs(from_date, todate){
            const {sortBy, sortDesc, page, itemsPerPage} = this.optionsDataTable
            console.log(sortBy, sortDesc)
            const task_type = this.filters.task_type
            const msg_type = this.filters.msg_type

            const squery = `start_date=${from_date}&end_date=${todate}&task_type=${task_type}&msg_type=${msg_type}&page=${page}&itemsPerPage=${itemsPerPage}&`
            this.loaded = true;
            axios.get('/logs/logs-records?'+squery)
                .then(resp=>{
                    /*
                    dataLogsRecords - list of records:
                        created_at: "2024-01-10 17:47:23.813000"
                        error_data: ""
                        event_type: "INFO"
                        id: 157
                        message_data: null
                        task_name: "TEST"
                        task_params: null
                    */
                    this.dataLogsRecords = resp.data.data;
                    this.dataLogsRecords = this.dataLogsRecords.map(el=>{
                        el = this.formatDateCreatedAt(el)
                        return el
                    })

                    const isNeedSetPageNumber = this.totalRows !== resp.data.count
                    this.totalRows = resp.data.count;
                    if (isNeedSetPageNumber) this.optionsDataTable.page = 1;
                    this.loaded = false;
                })

        },
        getTaskLastActivity(){
            this.loaded_t_last_acitivty = true;
            axios.get('/logs/logs-last-activities')
                .then(resp=>{
                    this.dataLogsLastActivityRecords = resp.data;
                    this.dataLogsLastActivityRecords = this.dataLogsLastActivityRecords.map(el=>{
                        return this.formatDateCreatedAt(el)

                    })
                    this.loaded_t_last_acitivty = false
                })
        },

        formatDateCreatedAt(el){
            if (!el['created_at']){
                el['created_at'] = 'Never started'
            }
            else{
                el['created_at'] =el['created_at'].substring(0,19)
            }
            return el
        },



        checkErrorsExist(){
            const errchecker = new ErrorsLogChecker(null)
            errchecker.getLastErrors().then(
                err_data=>{
                    let new_err_ids = err_data[0]
                    let new_err_ids_full = err_data[1]
                    this.errors_not_running = err_data[2]
                    if (errchecker.isNewErrorsExists( new_err_ids, this.errors_not_running ))
                    {
                      errchecker.setLastViewErrosInStore(new_err_ids_full);
                      this.errors_new = new_err_ids;
                        this.filters['msg_type'] = EMessageTypes.Error_type;
                    }

                }
            )
        },

        // table methods
        showScrollingArrows() {
            const el = document.querySelector('.v-data-table__wrapper')
            this.scrollLeft = el.scrollLeft
            this.scrollWidth = el.scrollWidth
            this.clientWidth = el.clientWidth

            const btnRight = document.querySelector('.btn-right-arrow')
            const btnLeft = document.querySelector('.btn-left-arrow')
            btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
            btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
        },

        scrollingRight() {
            const el = document.querySelector('.v-data-table__wrapper')

            el.scrollLeft = el.scrollLeft + 50

            const btnRight = document.querySelector('.btn-right-arrow')
            const btnLeft = document.querySelector('.btn-left-arrow')
            btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
            btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
        },
        scrollingLeft() {
            const el = document.querySelector('.v-data-table__wrapper')

            el.scrollLeft = el.scrollLeft - 50

            const btnLeft = document.querySelector('.btn-left-arrow')
            const btnRight = document.querySelector('.btn-right-arrow')
            btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
            btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
        },
        /*
        rowClick: function (item, row) {
            let selectState = (row.isSelected) ? false : true
            row.select(selectState)
        },

         */
        itemRowBackground:function (item){

            const utcnow = new Date().getTime();
            const utc_created = Date.parse(item.created_at + ' GMT')
            if( (utcnow - utc_created)/1000 >24*3600 ) return "v-data-table__selected";
            return '';
        },



    }
})
</script>


<style scoped>
.danger-alert_imp{
    background-color: #F8D7DA!important;
    color: #721C45!important;
}

.danger-alert{
    background-color: #F8D7DA;
    color: #721C45;
}
.danger-el-heigth{
    height: 3rem;
}
.danger-paddings{
    padding-bottom:3rem!important;
    padding-top:2rem!important;
}
</style>
